import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";
import Breadcrumb from "../Sections/contact/Breadcrumb";
import ContactForm from "../Sections/contact/ContactForm";
import Location from "../Sections/contact/Location";

function ContactUs() {
    const { data: {contact} } = useGetSettingQuery()

    return ( 
        <>
            {contact.topbar && <Breadcrumb/>}
            {contact.contact_form && <ContactForm/>}
            {contact.location && <Location/>}
        </>
    );
}

export default ContactUs;